var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Wrap',{attrs:{"title":_vm.$t('web_app.homeNotice.notice'),"show_clearAll":true},on:{"closeClick":_vm.handleCloseClick,"clearAllClick":_vm.markAll}},[_c('ScrollView',{staticClass:"messageList",attrs:{"height":_vm.windowInnnerHeight}},[_c('NoticeList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }